module.exports = __webpack_public_path__ + "img/bonuses.de64aa27.svg";